export default "__VITE_ASSET__DcT72nW0__"